import { CUSTOM_EVENTS } from "@/constants/custom-events";
import { OpenFollowupEmailDraftEventDataI } from "@/lib/types/events/email";
import { useEffect } from "react";
import { useEmailTemplatesContext } from "@/components/modules/email-templates-sidebar/context";

export const EmailTemapltesSidebarEvents = () => {
  const { activeTemplate, setDraft, initialDraft, setInitialDraft } =
    useEmailTemplatesContext();

  useEffect(() => {
    if (activeTemplate?.id && initialDraft) {
      setDraft(activeTemplate.id as string, {
        subject: initialDraft?.subject,
        body: initialDraft?.body,
        attachments: initialDraft?.attachments,
      });

      /**
       * Bug inside email editor,
       * Body is overrided on the initial load with undefined
       * This is a workaround to set the body
       * It should happen before Email form is mounted
       */
      setTimeout(() => {
        setDraft(activeTemplate.id as string, {
          subject: initialDraft?.subject,
          body: initialDraft?.body,
          attachments: initialDraft?.attachments,
        });

        setInitialDraft(undefined);
      }, 100);
    }
  }, [activeTemplate, initialDraft]);

  useEffect(() => {
    const eventHandler = (
      event: CustomEvent<OpenFollowupEmailDraftEventDataI>
    ) => {
      const draft = event?.detail?.draft;

      setInitialDraft(draft);
    };

    window.document.addEventListener(
      CUSTOM_EVENTS.ACCOUNT.EMAIL_TEMPLATES.OPEN_FOLLOWUP_DRAFT,
      eventHandler as EventListener
    );

    return () => {
      window.document.removeEventListener(
        CUSTOM_EVENTS.ACCOUNT.EMAIL_TEMPLATES.OPEN_FOLLOWUP_DRAFT,
        eventHandler as EventListener
      );
    };
  }, []);

  return null;
};
